import React from 'react';

import DeviceItem from '../DeviceItem';

import styles from './styles.module.scss';
import cn from 'classnames';
import Loader from '../../ui/Loader';

const DeviceSidebar = ({
  showAllDeviceBtn,
  subscriptions,
  selectedSubscription,
  setSelectedSubscription,
  className,
  isLoading = false,
  notAllowSelectNotAvailableSubs = false,
}) => {
  return (
    <>
      <div className={cn(styles.deviceSidebar, className)}>
        <h3 className={styles.deviceSidebarTitle}>
          You have {subscriptions?.length}
          {subscriptions?.length > 1 ? ' devices' : ' device'}
        </h3>
        <div className={styles.deviceSidebarWrapper}>
          <ul className={styles.deviceSidebarDevices}>
            {showAllDeviceBtn && (
              <DeviceItem
                clickHandler={setSelectedSubscription}
                selected={selectedSubscription === null}
                key={null}
                type={'all'}
              >
                All items
              </DeviceItem>
            )}
            {isLoading ? (
              <Loader className={styles.deviceSidebarLoader} show={isLoading} />
            ) : (
              subscriptions?.map((subscription) => (
                <DeviceItem
                  notAllowSelectNotAvailableSubs={
                    notAllowSelectNotAvailableSubs
                  }
                  deviceDetails={subscription}
                  clickHandler={setSelectedSubscription}
                  key={subscription.id}
                  selected={subscription.id === selectedSubscription}
                ></DeviceItem>
              ))
            )}
          </ul>
        </div>
      </div>
    </>
  );
};

export default DeviceSidebar;
